import { render, staticRenderFns } from "./ModalCopiarPrecos.vue?vue&type=template&id=98bf9184&"
import script from "./ModalCopiarPrecos.vue?vue&type=script&lang=js&"
export * from "./ModalCopiarPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports